import clientCookies from 'js-cookie';


const isServer = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);


class _Cookies {

    setAll(cookies)
    {
        this.cookies = cookies;
    }

    set(name, value)
    {
        this.cookies[name] = value;
    }


    get(name){
        return this.cookies[name];
    }

    remove(name){
        delete this.cookies[name];
    }
}
const Cookies = isServer ? clientCookies : new _Cookies();
export default Cookies;